// GX Design System Colors — sourced from Figma (node 2615:16750)

export const GX_SUCCESS = '#00E676';
export const GX_FAILURE = '#FF1744';
export const GX_HIGHLIGHT = '#E84E0F';
export const GX_HIGHLIGHT_LIGHT = '#FF7043';
export const GX_MAIN_BACKGROUND = '#070818';
export const GX_TILE_DARK = '#0D1228';
export const GX_TILE_LIGHT = '#121836';
export const GX_ADDITIONAL_PAPER = '#12163F';
export const GX_TEXT = '#F8F8F8';
export const GX_TEXT_SECONDARY = '#A1A6AB';
export const GX_TEXT_DISABLED = '#6C737A';
export const GX_NEUTRAL = '#4F5458';
export const GX_RESPONSE = '#1A224D';
export const GX_BORDER = '#4D5B88';
export const GX_SELECTION = '#31475A';
export const GX_FORWARD_HIGHLIGHT = '#10035D';
export const GX_SPOT_HIGHLIGHT = '#1F0808';
export const GX_MINI_TABLE_HIGHLIGHT = '#282F48';
export const GX_SUBTEXT = '#B0B0B0';
export const GX_CURVE_SELECTOR = '#1F295C';
export const GX_WARNING = '#CCAC00';
export const GX_FAILURE_LIGHT = '#FF4D6D';
export const GX_FAILURE_DARK = '#CC1236';
export const GX_INFO_MAIN = '#778899';

export const CHARTS_BLUE = '#00BFFF';
export const CHARTS_YELLOW = '#FFD700';
export const CHARTS_GREEN = '#2E8B57';
export const CHARTS_PURPLE = '#6363DF';
export const CHARTS_ORANGE = '#F3733F';

export type ChartColor = { name: string; hex: string };

export const vibrantPalette: ChartColor[] = [
  { name: 'Blue', hex: CHARTS_BLUE },
  { name: 'Green', hex: CHARTS_GREEN },
  { name: 'Yellow', hex: CHARTS_YELLOW },
  { name: 'Purple', hex: CHARTS_PURPLE },
  { name: 'Orange', hex: CHARTS_ORANGE },
  { name: 'Pink', hex: '#FF2D55' }
];

export const monoBluePalette: ChartColor[] = [
  { name: 'Light sky', hex: '#BDDEFF' },
  { name: 'Sky blue', hex: '#85C1F5' },
  { name: 'Ocean blue', hex: '#5BA7F7' },
  { name: 'Royal blue', hex: '#378CE4' },
  { name: 'Deep blue', hex: '#1976D2' },
  { name: 'Navy blue', hex: '#0D47A1' }
];

export const balancedPalette: ChartColor[] = [
  { name: 'Dusty blue', hex: '#8BB6C7' },
  { name: 'Sage green', hex: '#A8C09A' },
  { name: 'Warm beige', hex: '#D4B483' },
  { name: 'Lavender', hex: '#C4A5C7' },
  { name: 'Dusty rose', hex: '#D19B9B' },
  { name: 'Cool gray', hex: '#9EAAB0' }
];
